module.exports = "/img/_/_/_/assets/images//wooden_background.jpg?981e022eef5f9b8cc9645b364955851e";